export {
    BuyCloudPostOrderProvisioningPageTemplate,
    COMMA,
    COMMA_REGEX
} from "./buy-cloud-post-order-provisioning-page.template";
export { BuyCloudPostOrderProvisioningPageTemplate as default } from "./buy-cloud-post-order-provisioning-page.template";
